import React, { useState, useCallback } from 'react';
import localCookie from '@liepin/native-sweet-fe';
import CloseIcon from '@liepin/icon-c-fe/svg/icon-close-circle.svg';
import styled from './index._less';
import ContentRight from '../ContentRight';
import AdsContent from '../../../components/AdsContent'
import { FE_WWW_GUIDE_NEW, HAS_CLOSE } from '../../../common/js/constants';

export default () => {
  const [visible, setVisible] = useState(true);
  const handleClose = useCallback(() => {
    // 用户手动关闭浮层, 1天内不再重复弹出
    localCookie.set(FE_WWW_GUIDE_NEW, HAS_CLOSE, 1);
    setVisible(false);
  }, []);

  return visible ? (
    <>
      <div className="login-content">
        <div className="login-content-flex">
          <AdsContent className="reg-layer-content" />
          <div className="right">
            <ContentRight />
          </div>
        </div>
        <div className="reg-layer-close" onClick={handleClose}>
          <CloseIcon />
        </div>
      </div>
      <style jsx>{styled}</style>
    </>
  ) : null
}
